import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';
import { Observable } from 'rxjs';
import { IToastData } from '../../services/toast/toast.data';
import { List } from 'immutable';

@Component({
  selector: 'i2g-toast-messages',
  templateUrl: 'toast-messages.component.html',
  styleUrls: ['toast-messages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastMessagesComponent implements OnInit {
  toasts$: Observable<List<IToastData>>;

  constructor(private _toastService: ToastService) {}

  ngOnInit() {
    this.toasts$ = this._toastService.toasts$;
  }
}
